<template>
  <v-container  fluid style="height:100vh">
    <v-row v-if="loading">
        <v-container>
            <v-progress-linear class="my-10" indeterminate/>
            <h1 class="text-h5 text-center my-5">VERIFYING ...</h1>
        </v-container>
    </v-row>
    <v-row v-if="!loading" class="mx-auto mt-10" style="width:85%">
        <v-col md="6 py-auto">
            <v-card v-if="success" elevation="0" class="d-flex align-self-baseline mt-10">
                <v-card-text class="mt-2">
                    <h1 class="title text-h1 my-5">
                        Welcome 
                    </h1>
                    <h4 class="text-h4 my-4">Your account has been verified</h4>
                    <v-btn 
                        large 
                        color="primary" 
                        class="mt-4 btn-lower-case" 
                        rounded
                        to='/v2/dashboard'
                    >
                        Go to Dashboard
                    </v-btn>
                </v-card-text>
            </v-card>

            <v-card v-if="error" elevation="0" class="d-flex align-self-baseline mt-5">
                <v-card-text>
                
                    <span class=" text-h2 mt-5">
                        Sorry, Verification Failed !<span>&#128546;</span>
                    </span>
                    <h4 class="text-h4 my-1">Please request a new verification link</h4>
                    <v-btn 
                        large 
                        color="primary" 
                        class="mt-2 btn-lower-case" 
                        rounded
                        to='signin'
                    >
                        Go to Login
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col md="6" class="hidden-sm-and-down">
            <v-img v-if="success" size="20" :src="succesImage"/>
            <v-img v-if="error" size="120" class="" :src="errorImage"/>
        </v-col>

    </v-row>
  </v-container>
</template>

<script>
import verification_success from "@/assets/verification_succes.jpg";
import verification_error from "@/assets/verification_error.jpg";
import Logo from "@/assets/guiomentorLogo.png";
export default {
 
    data(){
        return{
            succesImage:verification_success,
            errorImage:verification_error,
            loading:false,
            error:null,
            success:null,
            logo:Logo,
            description: "Guiomentor is a platform directed to a niche of 10to 25 years old. Its objective is to help students to choose the best career or discipline for them according to their skills and part of interest "
  
        }
    },
        metaInfo() {
        return {
        title: 'Guiomentor - Email verification',
          url: window.location.href,
        meta: [
            {name: 'title', content: 'Guiomentor - Email verification'},
            {name: 'description', 
            content: this.description
            },
            //Facebook
            {name: 'og:type', content: 'Website'},
            {name: 'og:title', content: "Guiomentor - Email verification"},
            {name: 'og:description', content: this.description},
            {name: 'og:image', content: this.logo},

            // Twitter
            {name: 'twitter:card', content: 'summary_large_image'},
            {name: 'twitter:url', content: window.location.href},
            {name: 'twitter:title', content: "Guiomentor - Email verification"},
            {name: 'twitter:description', content: this.description},
            {name: 'twitter:image', content: this.logo},
        ]
        }
  },
    beforeMount() {
        // if (!this.$route.query.token) {
        // this.$router.push({name: 'signin'})
        // }
    },
    mounted(){
        this.verify()
    },
    methods: {
        async verify(){
            try {
                this.loading = true;
                let token = this.$route.query.token;
                await this.axios.get(`/users/email-verify/?token=${token}`);
                this.loading = false;
                this.error = false;
                this.success = true;
            } catch (error) {
                this.error = true;
                this.success = false;
                this.loading = false;
            } finally {
                 this.$analytics.logEvent("email_verification", {
                    time: new Date(),
                    url: window.location.href,
                    version: process.env.VUE_APP_VERSION,
                    environment: process.env.VUE_APP_ENVIRONMENT,
                });
            }
        }
    }
    
    
  }
</script>

<style scoped>

.btn-lower-case { 
    text-transform: none; 
}
</style>
